import script from "./PlatformGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformGoods.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformGoods.vue?vue&type=style&index=0&id=7669dd97&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7669dd97"]])

export default __exports__